// Last occurrence wins, insertion order preserved - a re-reported failure refreshes the row in place instead
// of appending a second one.
const byCandidacyId = rows => [...new Map(rows.map(row => [row.candidacyId, row])).values()];

// Merges a batch response into what the dialog already shows. Created accounts accumulate across batches so
// copy-all covers the whole session. Two rules matter:
//   * a candidacy that failed in an earlier batch and succeeded in a later one stops being listed as failed;
//   * a candidacy that failed more than once is listed once, not once per attempt.
export const mergeBatch = (previous, batch) => {
  const created = byCandidacyId([...(previous?.created ?? []), ...(batch.created ?? [])]);
  const createdIds = new Set(created.map(row => row.candidacyId));
  const failed = byCandidacyId([...(previous?.failed ?? []), ...(batch.failed ?? [])]).filter(
    row => !createdIds.has(row.candidacyId),
  );

  return {
    created,
    failed,
    batchSize: batch.batchSize,
    remainingCount: batch.remainingCount,
    skippedCount: batch.skippedCount ?? 0,
  };
};

export default mergeBatch;
